import { Redirect } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';

const Unauthorized = () => {
  let location = useLocation();

  return (
    <Container className="view-wrapper">
      <BodyClass className="view-unauthorized" />
      <Redirect
        to={{
          pathname: `${location.pathname.replace(/\/$/, '')}/login`,
          state: {
            // This is needed to cover the use case of being logged in in
            // another backend (eg. in development), having a token for
            // localhost and try to use it, the login route has to know that
            // it's the same as it comes from a logout
            isLogout: true,
          },
        }}
      />
    </Container>
  );
};
const UnauthorizedWithCode = withServerErrorCode(401)(Unauthorized);
UnauthorizedWithCode.displayName = 'unauthorized';
export default UnauthorizedWithCode;
